import React from 'react';
import { Tooltip } from 'reactstrap';

export default class Select extends React.Component {
    constructor(props) {
        super(props);
        this.toggleToolTip = this.toggleToolTip.bind(this);
        this.validateOnBlur = this.validateOnBlur.bind(this);
        this.state = {
            tooltipOpen: false,
            invalidInput: false
        };
    }

    toggleToolTip() {
        this.setState({
            tooltipOpen: !this.state.tooltipOpen
        });
    }

    onChange(event) {
        if (this.props.onChange)
            this.props.onChange(event, event.target.value, event.target.value.trim() !== '');
        this.validateOnBlur(event);
    }

    validateOnBlur(event) {
        if (this.props.required) {
            event.persist();
            if (event.target.value) {
                this.setState({ invalidInput: false });
            }
            else {
                this.setState({ invalidInput: true });
            }
        }
    }

    render() {
        const { placeholder, required, name, id, autoFocus, disabled, disableEmptyOption, value, options,
            renderedOptions, className, inputErrorMsg, tooltipID, tooltipMsg, prependIcon, showAsInvalid, onFocus
        } = this.props;
        var dynamicClass = className ? className : '';
        
        const containerClassName = (value || value === 0 ? " input-not-empty" : "") + (this.state.invalidInput || showAsInvalid ? " input-invalid" : "") + ((tooltipID && tooltipMsg) ? " input-append" : "");

        return (
            <div className={"il-group" + containerClassName}>
                    <select
                        className={"form-control " + dynamicClass}
                        required={required}
                        name={name}
                        id={id}
                        value={value}
                        disabled={disabled}
                        autoFocus={autoFocus}
                        aria-label={placeholder ? placeholder : ""}
                        onChange={e => this.onChange(e)}
                        onBlur={this.validateOnBlur}
                        onFocus={(e) => { if (onFocus) onFocus(e); }}
                        title={placeholder ? "Please fill out the " + placeholder : "Please fill out this field."}
                        ref="selectElement"
                    >
                        {!disableEmptyOption && <option value="" />}
                        {options && options.length > 0 ? options.map((opt, index) => {
                            return (
                                <option
                                    key={index}
                                    value={opt.value}>{opt.label}</option>
                            );
                        }) : renderedOptions}
                    </select>
                {(tooltipID && tooltipMsg) && <div className="input-icon-append ">
                    <span className="icon-info" id={tooltipID} />
                    <Tooltip placement="top" isOpen={this.state.tooltipOpen} autohide={false} target={tooltipID} toggle={this.toggleToolTip}>
                        {tooltipMsg}
                    </Tooltip>
                </div>}
                <div className="il-label" aria-hidden="true">{prependIcon && <span className={prependIcon} />} {placeholder}</div>
                {inputErrorMsg && <div className="input-error-msg">{inputErrorMsg}</div>}
            </div>
        );
    }
}